import React from 'react';
import { BRAND } from '../../data/siteData';
import WhatsAppIcon from './WhatsAppIcon';

const WHATSAPP_LINK = "https://wa.me/1" + BRAND.phone.replace(/\D/g, "");

export default function WhatsAppFloat() {
  return (
    <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-button"
      className="lg:hidden fixed bottom-20 right-4 z-40 flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#1EBE5B] rounded-full shadow-lg shadow-[#25D366]/40 transition-all">
      <WhatsAppIcon className="w-7 h-7 text-white" />
    </a>
  );
}
